import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { useMount } from 'react-use';
import { useGetStarterGuideOrganisations } from 'shared/data/myAccount/v2';
import { starterGuideCompaniesState } from 'shared/states';

export const useStarterGuideCompanies = (params: { enabled: boolean }) => {
    const { enabled } = params;

    const setStarterGuideCompanies = useSetAtom(starterGuideCompaniesState);

    const { data, isInitialLoading } = useGetStarterGuideOrganisations(
        undefined,
        {
            enabled,
        },
        {
            /**
             * Request errors interfere when working with the local API in dev.
             * This request is not critical for the application's functionality.
             */
            ignoreError: true,
        }
    );

    const [isLoading, setIsLoading] = useState(isInitialLoading);

    useEffect(() => {
        if (data?.organisationIds) {
            setStarterGuideCompanies(data.organisationIds);
        }

        // Set the loading flag after calling setStarterGuideCompanies.
        setIsLoading(isInitialLoading);
    }, [data, isInitialLoading, setStarterGuideCompanies]);

    useMount(() => {
        const timeout = setTimeout(() => {
            setIsLoading(false);
        }, 500);

        return () => clearTimeout(timeout);
    });

    return {
        isLoading,
    };
};
